import React from 'react'
import css from './style.module.scss'
import { Button } from 'components/ui'
import { deliveryTypes } from '../../constants'
import { Link } from 'gatsby'
import { map, find, propEq } from 'ramda'

function getCityById(id, cities) {
  return find(propEq('id', id), cities).name
}

function getFamilyMembersString(order) {
  if (order.family.length) {
    const a = map(fm => {
      return `${fm.last_name} ${fm.name} ${fm.patronymic}`
    }, order.family)

    return a.join(', ')
  }
}

const UserOrders = ({
  orders,
  cities,
  ordersOther,
  hasOrder,
}) => {
  return (
    <div className={css.accForm}>
      <div className={css.ordersItemList}>
        {orders.map((order, index) => (
          <div key={`user-orders-key-${index}`} className={css.ordersItem}>
            <p className="label-2 black">{`Заявка ${index + 1}`}</p>

            <div className={css.orderValue}>
              <p>{
                `Для себя в г. ${getCityById(order.city, cities)}`}
              </p>
              {(order.delivery === deliveryTypes.COURIER) && (
                <p>
                  Курьерская доставка,&nbsp;
                  {order.address}
                </p>
              )}
              {(order.delivery === deliveryTypes.PICKUP) && (
                <p>
                  Самовывоз
                </p>
              )}
              {order.family.length !== 0 &&
                <p>{`Члены семьи: ${getFamilyMembersString(order)}`}</p>
              }
            </div>

            {/*<a className="label-2 primary-color">Повторить заказ</a>*/}
          </div>
        ))}

        {ordersOther.map((order, index) => (
          <div key={`user-orders-key-${index}`} className={css.ordersItem}>
            <p className="label-2 black">{`Заявка ${(orders.length + index + 1)}`}</p>

            <div className={css.orderValue}>
              <p>{
                `Для других в г. ${getCityById(order.city, cities)}`}
              </p>
            </div>

            {/*<a className="label-2 primary-color">Повторить заказ</a>*/}
          </div>
        ))}
      </div>

      {
        hasOrder &&
          <div className={css.buttonWrap}>
            <Link to='/make-order/'>
              <Button blue className="form-button" text={'Оставить новую заявку'} />
            </Link>
          </div>
      }
    </div>
  )
}

export default UserOrders
